import { FillRequest } from 'entities/FillBtn';
import { NewTrip } from 'entities/Trip';
import { FieldLoadedType, FieldSuccssLoadedType } from './interfaces';
import {
  GET_TRIP_FIELDS_REQUEST,
  GET_TRIP_FIELDS_SUCCESS,
  GET_TRIP_FIELDS_ERROR,
  CLEAN_TRIP_FIELDS_LOADED,
  GET_REQDOC_ERROR,
  SET_TRIP_FIELDS,
  GET_ORDER_WEIGHT_REQUEST,
  GET_ORDER_WEIGHT_SUCCESS,
  GET_ORDER_WEIGHT_ERROR,
  GET_TRIP_ORDERS_REQUEST,
  GET_TRIP_ORDERS_ERROR,
  GET_TRIP_ORDERS_SUCCESS,
  GET_ORDER_PART_NUM_REQUEST,
  CLEAR_ERROR,
} from './constants';

export const setDatabaseTrip = (trip: NewTrip) => ({
  type: SET_TRIP_FIELDS,
  payload: trip,
});

export const setReqDocError = (error: boolean) => ({
  type: GET_REQDOC_ERROR,
  payload: error,
});

export const getTripFieldsRequest = (data: FillRequest) => ({
  type: GET_TRIP_FIELDS_REQUEST,
  paramName: data.paramName,
  payload: data,
});

export const getTripFieldsSuccess = (reqData: FieldSuccssLoadedType, loaded: FieldLoadedType) => ({
  type: GET_TRIP_FIELDS_SUCCESS,
  payload: { reqData, loaded },
});

export const getTripFieldsError = (data: FieldLoadedType) => ({
  type: GET_TRIP_FIELDS_ERROR,
  payload: data,
});

export const getTripOrdersRequest = (orderObject: string, tripValue: any) => ({
  type: GET_TRIP_ORDERS_REQUEST,
  payload: { orderObject, tripValue },
});

export const getOrderPartNumRequest = (orderPartNum: string, tripValue: any) => ({
  type: GET_ORDER_PART_NUM_REQUEST,
  payload: { orderPartNum, tripValue },
});

export const getTripOrdersSuccess = () => ({
  type: GET_TRIP_ORDERS_SUCCESS,
});
export const getTripOrdersError = (error: any) => ({
  type: GET_TRIP_ORDERS_ERROR,
  payload: error,
});

export const getOrderWeightRequest = (tripValue: any) => ({
  type: GET_ORDER_WEIGHT_REQUEST,
  payload: { tripValue },
});

export const getOrderWeightSuccess = () => ({
  type: GET_ORDER_WEIGHT_SUCCESS,
});

export const getOrderWeightError = (error: any) => ({
  type: GET_ORDER_WEIGHT_ERROR,
  payload: error,
});

export const cleanTripFields = () => ({
  type: CLEAN_TRIP_FIELDS_LOADED,
});

export const clearError = () => ({
  type: CLEAR_ERROR,
});

export type Actions =
  | ReturnType<typeof setDatabaseTrip>
  | ReturnType<typeof setReqDocError>
  | ReturnType<typeof getTripFieldsRequest>
  | ReturnType<typeof getTripFieldsSuccess>
  | ReturnType<typeof getTripFieldsError>
  | ReturnType<typeof getOrderWeightRequest>
  | ReturnType<typeof getOrderWeightSuccess>
  | ReturnType<typeof getOrderWeightError>
  | ReturnType<typeof getTripOrdersRequest>
  | ReturnType<typeof getOrderPartNumRequest>
  | ReturnType<typeof getTripOrdersError>
  | ReturnType<typeof getTripOrdersSuccess>
  | ReturnType<typeof clearError>
  | ReturnType<typeof cleanTripFields>;
